import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { readInviteStash } from './inviteToken'

/**
 * "Is there a team invite waiting for this person?"
 *
 * The counterweight to `InviteWatcher`'s one-shot redirect. Once an invite has
 * been delivered once it is never forced again — so it has to be reachable
 * somewhere ORDINARY, or declining it by accident would lose it until the
 * invitee went back to their inbox. Both nav surfaces (the desktop account menu
 * and the mobile Profile screen) render a row from this.
 *
 * Re-read on every navigation rather than subscribed to: sessionStorage fires
 * no same-tab event, and the two consumers re-render on route change anyway.
 * The value is a plain token string, so a null is simply "no row".
 */
export function usePendingInvite(): string | null {
  const location = useLocation()
  const [token, setToken] = useState<string | null>(() => readInviteStash()?.token ?? null)

  useEffect(() => {
    setToken(readInviteStash()?.token ?? null)
  }, [location.pathname, location.search])

  return token
}
